import script from "./PopupContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopupContainer.vue?vue&type=script&setup=true&lang=ts"

import "./PopupContainer.vue?vue&type=style&index=0&id=2aac12ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2aac12ea"]])

export default __exports__